import { FC } from 'react';
import { Col, Container, Image, ListGroup, Row } from 'react-bootstrap';

interface InfoItemProps {
    icon?: string;
    content: React.ReactNode;
}

const InfoItem: FC<InfoItemProps> = ({ icon, content }) => (
    <ListGroup.Item>
        <Container fluid>
            <Row>
                <Col xs={1}>{icon && <Image src={icon} alt="" />}</Col>
                <Col>{content}</Col>
            </Row>
        </Container>
    </ListGroup.Item>
);

export default InfoItem;
